import type { Team } from '@/core/schemas';

import type { Seed } from './contracts';

/**
 * Brings the teams into the order the engine expects.
 *
 * Teams with a seeding position set by the tournament director come first, in
 * that order; the rest follow alphabetically so the draw is reproducible
 * instead of depending on document order.
 *
 * Pure and framework-free, so both the app and the Cloud Function that drives
 * the tournament from the server can plan a phase from the same seeding.
 */
export function toSeeds(teams: readonly Team[]): Seed[] {
  return [...teams]
    .filter((team) => team.status === 'active')
    .sort((a, b) => {
      if (a.seed !== null && b.seed !== null) return a.seed - b.seed;
      if (a.seed !== null) return -1;
      if (b.seed !== null) return 1;
      return a.name.localeCompare(b.name, 'de-DE');
    })
    .map((team, index) => ({
      teamId: team.id,
      rank: index + 1,
      label: team.name,
    }));
}
